import {AxiosResponse} from "axios";
import {BaseMutationOptions, BaseUseMutationResult, useBaseMutation} from "@bounce/shared/requests";
import {axiosReachInstance} from "../../ReachApiManager";
import {ASSETS_QUERY_KEY} from "../queryKeys";

type BatchDeleteAssetsVariables = {assetIds: number[]};

const batchDeleteAssets = async ({assetIds}: BatchDeleteAssetsVariables): Promise<boolean> => {
  const response = await axiosReachInstance.post<boolean, AxiosResponse<boolean>>("/assets/batch-delete", {
    asset_ids: assetIds,
  });
  return response.data;
};

export const useBatchDeleteAssets = (
  options?: BaseMutationOptions<boolean, BatchDeleteAssetsVariables>
): BaseUseMutationResult<boolean, BatchDeleteAssetsVariables> => {
  return useBaseMutation<boolean, BatchDeleteAssetsVariables>(batchDeleteAssets, {
    ...options,
    prefixKeysToInvalidate: () => [[ASSETS_QUERY_KEY]],
  });
};
